import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, addDays } from "date-fns";
import Modal from "react-modal";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import CmnLeadCards from "./CmnLeadCards";
import CmnFilters from "./common/CmnFilters";
import LeadGlobalFilter from "./common/LeadGlobalFilter";
import ModalHeader from "../ModalHeader";
import SelectExportables from "../common-components/SelectExportables";
import { leadExportableData } from "../pt-trials/common/SharedDatas";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";
import { exportLead } from "../../data/ApiEndpoints";
import {
  extractConvertedTo,
  extractFollowupTimes,
} from "./raw-leads/RawLeadCommon";
// import ReactCountUp from "../components-react/ReactCountUp";
// import { formatTimezoneThenStraight } from "../common-data/Converts";
import CommonBroadForm from "../common-components/broadcast-template/CommonBroadForm";
import { isDev } from "../common-data/Commons";
import { isBroadcastCreateAllowedEmail } from "../common-data/Accessibles";
import "../../styles/lead-mangement/lms.css";

const LeadFilters = ({
  userInfoData,
  allFilters,
  setAllFilters,
  iniAllFilter,
  filters,
  setFilters,
  tableRef,
  mobileTableRef,
  setIsConvertedModal,
  isAdminView,
  rawLeads,
  setRawLeads,
  setIsPage,
}) => {
  const dispatch = useDispatch();
  const { exportData, exportLoading } = useSelector((state) => state.common);
  const { rawLeadStats } = useSelector((state) => state.api);

  const isBroadcastCreateAllowed =
    isDev || isBroadcastCreateAllowedEmail(userInfoData?.email);

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const initialClickValues = {
    isModOpen: false,
    name: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [csvData, setCsvData] = useState();
  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [lastAssigned, setLastAssigned] = useState(
    rawLeadStats?.last_added_to_lead ? rawLeadStats.last_added_to_lead : null
  );

  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);

  const onCloseModal = () => {
    setClickValues(initialClickValues);
    setCsvData();
    setIsFilterSegmentShown(true);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      followupStartDate: formattedStartDate,
      followupEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      followupStartDate: "",
      followupEndDate: "",
    });
  };

  const onClickLeadCard = (key) => {
    setAllFilters((prevs) => ({
      ...prevs,
      clickedCard: key,
    }));
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getExportedData(filters) {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: exportLead,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  useEffect(() => {
    const { followup_times } = extractFollowupTimes(allFilters.selFollowupTime);
    const { converted_days_ago } = extractConvertedTo(
      allFilters.selConvertedIn
    );

    setFilters((prevs) => ({
      ...prevs,
      filter_type: allFilters.clickedCard ? allFilters.clickedCard : "all",
      gym_id: allFilters.selectedGym?.value || "",
      assigned_to: allFilters.selAssignee?.value || "",
      assignee_deleted: allFilters.selectedAssigneeStatus?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      lead_status: allFilters.selLeadStatus?.value || "",
      follow_up_status: allFilters.selFollowupStatus?.value || "",
      source_name: allFilters.selLeadSource?.value || "",
      utm_source: allFilters.selUTMSource?.value || "",
      btl_vendor_id: allFilters.selectedVendor?.value || "",
      lead_type: allFilters.selCard?.value || "",
      plan_type: allFilters.setPlan?.value || "",
      customer_intent_id: allFilters.selCustomerIntent?.value || "",
      followup_time: followup_times || "",
      is_raw_lead: allFilters.selIsRaw?.value || "",
      follow_up_number: allFilters.selFollowupStage?.value || "",
      lead_from: allFilters.selLeadFrom?.value || "",
      conversion_days: converted_days_ago || "",
      operator_value: allFilters.selOperatorValue?.value || "",
      wap_image: allFilters.selectedWhatsappVerification?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      followup_date_start: allFilters.leadFollowupDateFrom || "",
      followup_date_end: allFilters.leadFollowupDateTo || "",
      follow_up_date_from: allFilters.leadLastFollowupDateFrom || "",
      follow_up_date_to: allFilters.leadLastFollowupDateTo || "",
      expected_closure_date_from: allFilters.leadClosureDateFrom || "",
      expected_closure_date_to: allFilters.leadClosureDateTo || "",
      converted_date_from: allFilters.leadConvertedDateFrom || "",
      converted_date_to: allFilters.leadConvertedDateTo || "",
      rawlead_start_date: allFilters.rawLeadAddDateFrom || "",
      rawlead_end_date: allFilters.rawLeadAddDateTo || "",
    }));
    setIsPage(0);
  }, [
    allFilters.clickedCard,
    allFilters.selectedGym,
    allFilters.selAssignee,
    allFilters.selectedAssigneeStatus,
    allFilters.selAddedby,
    allFilters.selLeadStatus,
    allFilters.selFollowupStatus,
    allFilters.selLeadSource,
    allFilters.selUTMSource,
    allFilters.selectedVendor,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadFollowupDateFrom,
    allFilters.leadFollowupDateTo,
    allFilters.leadClosureDateFrom,
    allFilters.leadClosureDateTo,
    allFilters.leadLastFollowupDateFrom,
    allFilters.leadLastFollowupDateTo,
    allFilters.selCard,
    allFilters.setPlan,
    allFilters.selIsRaw,
    allFilters.selFollowupStage,
    allFilters.selLeadFrom,
    allFilters.selFollowupTime,
    allFilters.selConvertedIn,
    allFilters.selCustomerIntent,
    allFilters.selOperatorValue,
    allFilters.leadConvertedDateFrom,
    allFilters.leadConvertedDateTo,
    allFilters.rawLeadAddDateFrom,
    allFilters.rawLeadAddDateTo,
    allFilters.selectedWhatsappVerification,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.name === "broadcast_data"
              ? "mod-height-95vh broadcast-modal"
              : ""
          }`}
        >
          <ModalHeader
            title={
              clickValues.name === "exportModal"
                ? "Select Fields To Export"
                : clickValues.name === "broadcast_data"
                ? "Broadcast Message"
                : clickValues.name?.replace(/_/g, "")
            }
            onClick={onCloseModal}
          />

          {clickValues.name === "exportModal" ? (
            <div>
              <SelectExportables
                name={"leads"}
                exportableData={leadExportableData}
                filters={filters}
                callFunction={onClickExport}
                isLoadingCSV={exportLoading}
                csvData={csvData}
                setCsvData={setCsvData}
              />
            </div>
          ) : clickValues.name === "broadcast_data" ? (
            <>
              {isFilterSegmentShown && (
                <CmnFilters
                  from={"lead-management"}
                  isSegment={true}
                  userInfoData={userInfoData}
                  onClickReset={onResetFilters}
                  filters={allFilters}
                  setFilters={setAllFilters}
                  followupHandleDate={handleDateRangeChange}
                  followupRangeState={rangeState}
                  followupOpenDateRanger={openDateRanger}
                  setFollowupOpenDateRanger={setOpenDateRanger}
                  clearFollowupDateRanger={clearDateRanger}
                  isAdminView={isAdminView}
                  setActiveCardIndex={setActiveCardIndex}
                />
              )}

              <CommonBroadForm
                from={"lms"}
                filters={filters}
                userInfoData={userInfoData}
                closeModal={onCloseModal}
                setIsFilterSegmentShown={setIsFilterSegmentShown}
              />
            </>
          ) : null}
        </div>
      </Modal>

      {/* <Row>
        <Col>
          {lastAssigned && (
            <div className="counter-up-container flexStart mt15">
              <div className="alert alert-danger" role="alert">
                Last Add To LMS Pending Since (
                {lastAssigned?.date_added
                  ? formatTimezoneThenStraight(lastAssigned.date_added)
                  : ""}
                ) : <ReactCountUp dateAndTime={lastAssigned?.date_added} />
              </div>
            </div>
          )}
        </Col>
      </Row> */}

      <Row>
        <Col>
          <LeadGlobalFilter
            from={"lead-management"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnLeadCards
            onClickLeadCard={onClickLeadCard}
            prevClickedCard={allFilters.clickedCard}
            tableRef={tableRef}
            mobileTableRef={mobileTableRef}
            setIsConvertedModal={setIsConvertedModal}
            rawLeads={rawLeads}
            setRawLeads={setRawLeads}
            activeCardIndex={activeCardIndex}
            setActiveCardIndex={setActiveCardIndex}
            setLastAssigned={setLastAssigned}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from={"lead-management"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            followupHandleDate={handleDateRangeChange}
            followupRangeState={rangeState}
            followupOpenDateRanger={openDateRanger}
            setFollowupOpenDateRanger={setOpenDateRanger}
            clearFollowupDateRanger={clearDateRanger}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isAdminView={isAdminView}
            onClickExportBtn={() =>
              setClickValues({
                isModOpen: true,
                name: "exportModal",
              })
            }
            onClickBroadcastBtn={
              isBroadcastCreateAllowed
                ? () =>
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      name: "broadcast_data",
                    }))
                : null
            }
            setActiveCardIndex={setActiveCardIndex}
          />
        </Col>
      </Row>
    </>
  );
};

export default LeadFilters;
